import { Actions } from "../constants/actionTypes";

export function paymentsReducer(state = {}, action) {
  if (action.type === Actions.SET_UPCOMING_INVOICE) {
    return {
      ...state,
      upcomingInvoice: action.data,
    };
  } else if (action.type === Actions.SET_INVOICE_HISTORY) {
    return {
      ...state,
      invoiceHistory: action.data,
    };
  } else if (action.type === Actions.SET_STRIPE_INVOICE) {
    return {
      ...state,
      stripeInvoice: action.data,
    };
  } else if (action.type === Actions.SET_STRIPE_UPCOMING_INVOICE) {
    return {
      ...state,
      stripeUpcomingInvoice: action.data,
    };
  } else if (action.type === Actions.SET_TIMELINEGRAPH_DETAILS) {
    return {
      ...state,
      graphData: action.data,
    };
  } else if (action.type === Actions.SET_USER_CARDS) {
    return {
      ...state,
      userCards: action.data,
    };
  } else if (action.type === Actions.SET_CASHFREE_DISCOUNT) {
    return {
      ...state,
      couponCode: action.data,
    };
  } else if (action.type === Actions.SET_BILL_DETAILS) {
    return {
      ...state,
      paymentPath: action.data,
    };
  } else if (action.type === Actions.SET_FETCH_STATUS) {
    return {
      ...state,
      fetchStatus: action.data,
    };
  }
  return { ...state };
}
